import qs from 'qs';
import cleanDeep from 'clean-deep';
import { IS_SNAP, SNAP_SHOT_LIMIT } from 'variables/main';

const CoursesEndpoint = {
  dataURL: 'education/courses',
  sourceName: 'educationCourses',
  autoLoad: true,
  getDataUrl: (url, { page, perPage, filters: { name, ...filtersRest }, sort, search }) => {
    // Ensure comma-separated filter values remain as strings (not arrays)
    const normalizedFilters = {};
    Object.entries(filtersRest).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        // Convert arrays to comma-separated strings for filters that need it
        if (Array.isArray(value)) {
          normalizedFilters[key] = value.filter(Boolean).join(',');
        } else {
          normalizedFilters[key] = value;
        }
      }
    });

    const urlData = {
      filters: { ...normalizedFilters, search: name },
      sort
    };

    if (search) {
      urlData.search = search;
    }

    const offset = ((page || 1) - 1) * perPage;

    urlData.offset = offset;

    urlData.limit = IS_SNAP ? SNAP_SHOT_LIMIT : perPage;

    const queryString = qs.stringify(cleanDeep(urlData, { NaNValues: true }));

    return url + (queryString && '?' + queryString);
  },
  mapData: (payload, state, concat) => {
    const { meta } = payload;
    const { limit, count, offset } = meta || {};

    return {
      data: concat ? (state.data || []).concat(payload) : payload,
      page: Math.ceil(Number(offset) / Number(limit)) + 1,
      perPage: limit,
      count
    };
  }
};

export default CoursesEndpoint;
